module.exports = {"630222100":"川口镇","630222101":"古鄯镇","630222102":"马营镇","630222103":"官亭镇","630222104":"巴州镇","630222105":"满坪镇","630222106":"李二堡镇","630222107":"峡门镇","630222200":"马场垣乡","630222201":"北山乡","630222202":"松树乡","630222203":"西沟乡","630222204":"总堡乡","630222205":"隆治乡","630222206":"大庄乡","630222207":"转导乡","630222208":"前河乡","630222209":"甘沟乡","630222210":"中川乡","630222211":"杏儿乡","630222212":"核桃庄乡","630222213":"新民乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630222.json
// module id = 2775
// module chunks = 0